/**
 * Reads the `?redirect=` query param and returns it as a safe, same-origin
 * relative path, or null when absent/unsafe. Guest-only auth middleware
 * appends this param when it sends a visitor here from a protected page
 * (e.g. /checkout) so they can be sent back after they authenticate.
 */
export function safeRedirectParam(): string | null {
  if (typeof window === 'undefined') return null;

  const redirect = new URLSearchParams(window.location.search).get('redirect');
  if (!redirect) return null;

  try {
    const url = new URL(redirect, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return url.pathname + url.search;
  } catch {
    return null;
  }
}
